"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _objectAssign = _interopRequireDefault(require("object-assign"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor
              ? Object.getOwnPropertyDescriptor(obj, key)
              : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

// @ts-ignore
var Iframe = function Iframe(_ref) {
  var url = _ref.url,
    allowFullScreen = _ref.allowFullScreen,
    position = _ref.position,
    display = _ref.display,
    height = _ref.height,
    width = _ref.width,
    overflow = _ref.overflow,
    styles = _ref.styles,
    onLoad = _ref.onLoad,
    onMouseOver = _ref.onMouseOver,
    onMouseOut = _ref.onMouseOut,
    scrolling = _ref.scrolling,
    id = _ref.id,
    frameBorder = _ref.frameBorder,
    ariaHidden = _ref.ariaHidden,
    sandbox = _ref.sandbox,
    allow = _ref.allow,
    className = _ref.className,
    title = _ref.title,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledby = _ref.ariaLabelledby,
    name = _ref.name,
    target = _ref.target;
  var iFrameRef = (0, _react.createRef)();
  var defaultProps = (0, _objectAssign.default)({
    ref: iFrameRef,
    src: url,
    target: target || "_parent",
    allowFullScreen: allowFullScreen || false,
    style: {
      position: position || "absolute",
      display: display || "block",
      height: height || "100%",
      width: width || "100%",
      overflow: overflow || "hidden"
    },
    scrolling: scrolling || "no",
    frameBorder: frameBorder || 0,
    height: height || "100%",
    sandbox: sandbox || null,
    name: name || null,
    className: className || null,
    title: title || null,
    allow: allow || null,
    id: id || null,
    "aria-labelledby": ariaLabelledby || null,
    "aria-hidden": ariaHidden || null,
    width: width || "100%",
    onLoad: onLoad || null,
    onMouseOver: onMouseOver || null,
    onMouseOut: onMouseOut || null
  });
  var props = Object.create(null);

  for (
    var _i = 0, _Object$keys = Object.keys(defaultProps);
    _i < _Object$keys.length;
    _i++
  ) {
    var prop = _Object$keys[_i];

    if (defaultProps[prop] != null) {
      props[prop] = defaultProps[prop];
    }
  }

  return _react.default.createElement("iframe", Object.assign({}, props));
};

var _default = Iframe;
exports.default = _default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-iframe/dist/es/iframe.js
// module id = 1184
// module chunks = 0